import { IUser } from '../../interfaces/models/user';
import { isMobileDevice } from '../../utils';
import { shouldSuppressLegacySyncConnectionsModal } from './onboardingSurveyUtils';

export const LINKEDIN_CONNECT_DISMISSED_SESSION_KEY = 'ld_linkedin_connect_dismissed';
export const LINKEDIN_SYNC_DECLINED_SESSION_KEY = 'ld_linkedin_sync_declined';
export const OPEN_LINKEDIN_CONNECT_MODAL_EVENT = 'ld:open-linkedin-connect-modal';

export const hasConnectedLinkedInProfile = (user?: IUser | null): boolean =>
    Boolean(user?.linkedinData?.publicIdentifier);

export const openConnectLinkedInProfileModal = (): void => {
    if (isMobileDevice()) return;
    try {
        sessionStorage.removeItem(LINKEDIN_CONNECT_DISMISSED_SESSION_KEY);
        sessionStorage.removeItem(LINKEDIN_SYNC_DECLINED_SESSION_KEY);
    } catch {
        /* ignore */
    }
    window.dispatchEvent(new CustomEvent(OPEN_LINKEDIN_CONNECT_MODAL_EVENT));
};

type TriggerManualLinkedInSyncParams = {
    user?: IUser | null;
    extensionInstalled: boolean;
    onboardingStep?: number;
    onSync: () => void;
    onLegacySyncModal: () => void;
};

/** Home / connections table sync: connect modal if no LI profile, else sync (legacy confirm modal when applicable). */
export const triggerManualLinkedInSync = ({
    user,
    extensionInstalled,
    onboardingStep,
    onSync,
    onLegacySyncModal,
}: TriggerManualLinkedInSyncParams): void => {
    if (!extensionInstalled || !user || isMobileDevice()) return;

    if (!hasConnectedLinkedInProfile(user)) {
        openConnectLinkedInProfileModal();
        return;
    }

    if (shouldSuppressLegacySyncConnectionsModal(user, onboardingStep)) {
        openConnectLinkedInProfileModal();
        return;
    }

    onLegacySyncModal();
};
